export default "__VITE_ASSET__10b0a79a__"